// /**
// * Key code list object
// */

type BreakpointList = {
  [key: string]: number;
};

export const breakpoints: BreakpointList = {
  mobile: 360,
  tablet: 768,
  tabletLandscape: 1024,
  desktop: 1440,
  wide: 1600
};
